import { NgModule } from '@angular/core';
import { GetCompanyAccountsStoreService } from './get-company-accounts-store.service';

@NgModule({
  providers: [GetCompanyAccountsStoreService],
})
export class GetCompanyAccountsStoreServiceModule {}
